import { Component, OnInit, Input, OnChanges, ViewChild, Output, EventEmitter, inject, DestroyRef, SimpleChanges } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Constants } from 'src/app/models/constants';
import { Table } from 'primeng/table';
import { SharedService } from 'src/app/services/shared/shared.service';
import { StorageService } from 'src/app/services/storage.service';
import { DateTimeService } from 'src/app/services/date-time/date-time.service';
import { FilterFieldConfig } from 'src/app/postlogin/common/filter-sidebar/filter-sidebar.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { startWith } from 'rxjs';

@Component({
  selector: 'app-colgroup-table',
  standalone: false,
  templateUrl: './colgroup-table.component.html',
  styleUrls: ['./colgroup-table.component.scss']
})
export class ColgroupTableComponent implements OnInit, OnChanges {
  private destroyRef = inject(DestroyRef);
  lang: string;
  @Input() isSidebarLayout: boolean = false;

  currentScreenData: currentDataDto[] = [];
  currentTempData: any[] = [];
  selectedList: any = [];
  selectedRows: any;
  einvoiceList: any;
  eyfileStatusList: any;
  noneyfileStatusList: any;
  eyfileStatusList1: any;
  noneyfileStatusList1: any;
  progressList: any;
  sourceList: any;

  @ViewChild('dt') dt: Table | undefined;
  uploaded: string;
  PREUPLOADED: string;
  inProgress: string;
  processed: string;
  failed: string;
  transformationFailed: string;
  T_INPROGRESS: string;
  pendingWithAttachLabel: string;
  Mapping_8: string;
  initialDataScreenData = [];
  isSorted: boolean = null;
  private currentSortField: string = null;
  globalSearchText: string = '';
  private preSearchScreenData: any[] = [];
  footerMessage: string = '';
  isGlobalFilterActive: boolean = false;
  private currentPageIndex: number = 0;

  public selectedCountry: string;
  @Input() webUploaded: any = [];
  @Input() isManual: boolean = true;
  @Input() userList: any;
  @Input() countryLocation: string;
  @Output() selected = new EventEmitter<any>();
  @Output() uploadButtonClick = new EventEmitter<any>();
  @Input() displayGVRTcolumn: boolean = false;
  @Input() downloadFromTable: boolean = false;
  @Input() tabName: any;

  // Sidebar-layout toolbar inputs
  @Input() filterFields: FilterFieldConfig[] = [];
  @Input() activeFilters: Record<string, any> = {};
  @Input() tableData: any[] = [];
  @Input() downloadTblType: string = '';
  @Input() currentTab: number = 1;
  @Input() mofCheck: boolean = false;
  @Input() showFilterSideBar: boolean = false;
  @Input() filterSidebarTitle: string = 'text.filterSidebarTitle';

  // Sidebar-layout toolbar outputs
  @Output() mofCheckChange = new EventEmitter<boolean>();
  @Output() switchMofChange = new EventEmitter<void>();
  @Output() refreshClick = new EventEmitter<void>();
  @Output() showFilterSideBarChange = new EventEmitter<boolean>();
  @Output() filterSubmit = new EventEmitter<Record<string, any>>();
  @Output() filterClear = new EventEmitter<Record<string, any>>();
  @Output() chipRemove = new EventEmitter<{ fieldName: string; value?: any }>();
  @Output() chipClearAll = new EventEmitter<void>();

  // Server-side pagination inputs/outputs (lazy mode when isSidebarLayout)
  @Input() totalRecords: number = 0;
  @Input() lazyRows: number = 25;
  @Input() lazyRowsPerPageOptions: number[] = [25, 50, 75, 100];
  @Output() tableEvent = new EventEmitter<{ type: string; data?: any }>();

  // Async download output (relayed from download-table)
  @Output() downloadTableData = new EventEmitter<any>();
  @Output() clearSelectedRowsEvent = new EventEmitter<any>();

  constructor(
    private translate: TranslateService,
    private dateTimeService: DateTimeService,
    private storageService: StorageService) {

  }

  async ngOnInit() {
    this.selectedCountry = this.storageService.getWithDefaultPassphrase("Country");

    this.originalStatusNames();

    this.translate.onLangChange
      .pipe(
        startWith({ lang: this.translate.currentLang || this.translate.getDefaultLang() } as LangChangeEvent),
        takeUntilDestroyed(this.destroyRef))
      .subscribe((event: LangChangeEvent) => {
        this.lang = event.lang;
        this.updateSourceList();
        this.updateEinvoicelist();
        this.updatefileStatusList();

        this.getCurrentScreenData();
      });

    this.progressList = {
      ULD: 0,
      INPROGRESS: 50,
      VAL: 40,
      STG: 60,
      IRP: 80,
      CTD: 100,
      PROCESSED: 90
    };
  }

  ngOnChanges(changes: SimpleChanges) {
    // Skip data rebuild for inputs that don't affect table data
    const nonDataKeys = ['showFilterSideBar', 'filterFields', 'isSidebarLayout'];
    // In sidebar (server-side) mode, filter changes are applied via a fresh fetch,
    // so an activeFilters-only change must not rebuild stale rows before the new data arrives.
    if (this.isSidebarLayout) {
      nonDataKeys.push('activeFilters');
    }
    const changedKeys = Object.keys(changes);
    const onlyNonData = changedKeys.every(key => nonDataKeys.includes(key));
    if (onlyNonData) {
      return;
    }
    this.getCurrentScreenData();
  }

  getCurrentScreenData() {
    this.currentScreenData = [];
    this.initialDataScreenData = [];
    if (!this.isSidebarLayout) {
      this.isSorted = null;
    }
    this.currentTempData = this.webUploaded;
    if (this.currentTempData) {
      this.translate.get(['text.standardInvoice', 'text.deleteInvoice', 'text.standardInvoiceAttachment', 'text.rulePrefix']).subscribe(res => {
        const rulePrefix = ['PL', 'FR'].includes(this.selectedCountry) ? (res['text.rulePrefix'] || 'Rule') : 'Rule';
        this.currentTempData.forEach(key => {
          let fileType = key.FileTemplate;
          if (key.FileTemplate === "Standard Invoice") {
            fileType = res['text.standardInvoice'];
          } else if (key.FileTemplate === "Delete") {
            fileType = res['text.deleteInvoice'];
          } else if (key.FileTemplate === "Standard Invoice - Attachment") {
            fileType = res['text.standardInvoiceAttachment'];
          }
          this.currentScreenData.push(new currentDataDto(
            key.FromDate ? key.FromDate : "",
            key.ToDate ? key.ToDate : "",
            key.MOFInterface ? key.MOFInterface : "",
            key.Entity ? key.Entity : "",
            this.sourceList[key.Source] ? this.translate.instant(this.sourceList[key.Source]["name"]) : "",
            fileType,
            this.einvoiceList[key.Type] ? this.einvoiceList[key.Type]["name"] : key.Type || "",
            key.Id ? key.Id : "", key.Status ? this.handleStatus(key) : "",
            key.Active ? key.Active : 0,
            key.Active_Errors ? key.Active_Errors : 0,
            key.Date ? key.Date : "",
            key.Date ? this.selectedCountry === 'MY' ? this.dateTimeService.formatDateFromUTCTolocalDate(key.Date) : key.Date : "",
            key.Error ? key.Error : "",
            key.FileID ? key.FileID : "",
            key.FileName ? key.FileName : "",
            key.FileStandard ? key.FileStandard : "",
            key.Interfacing_with_MoF ? key.Interfacing_with_MoF : "",
            key.OrgFileName ? key.OrgFileName : "",
            key.Stage ? key.Stage : "",
            key.Structure ? key.Structure : "",
            this.userList[key.System_ID],
            key.Total_Received ? key.Total_Received : 0,
            key.In_Progress_KSeF ? key.In_Progress_KSeF : 0,
            key.Transformation ? key.Transformation : "",
            key.Success_KSeF ? key.Success_KSeF : 0,
            key.Errors_KSeF ? key.Errors_KSeF : 0,
            key.Inactive ? key.Inactive : 0,
            key.InActive_Errors ? key.InActive_Errors : 0,
            key.FileTemplate,
            this.einvoiceList[key.Type] ? this.einvoiceList[key.Type]["name"] : (key.Type === 'B2C' ? 'No Transformation' : key.Type === 'LIFECYCLE'? 'No Transformation' : key.Type === 'ERPT' ? 'No Transformation' : rulePrefix + ' '+ key.Type ),
            key?.GVRT_Status ? key.GVRT_Status : this.handleGvrtStatus(key),
            key.GVRT_StartDT ? key.GVRT_StartDT : "",
            key.Status ? key.Status : ""));
        });
        this.initialDataScreenData = [...this.currentScreenData];
        this.isGlobalFilterActive = false;
        this.preSearchScreenData = [];
        this.updateFooterMessage();
      });
    }
    
    if (this.currentScreenData) {
      const translationKeys = [
        'text.dataStatusError1',
        'text.dataStatusError2',
        'text.dataStatusError3',
        'text.dataStatusError4',
        'text.dataStatusError5',
        'text.dataStatusError6',
        'text.dataStatusError7',
        'text.dataStatusError8',
        'text.dataStatusError9',
        'text.dataStatusError10'
      ];
      this.translate.get(translationKeys).subscribe(res => {
        this.currentScreenData.forEach(element => {
          if (element.Error) {
            if (element.Error == Constants.dataStatusError1) {
              element.Error = res['text.dataStatusError1'];
            } else if (element.Error == Constants.dataStatusError2) {
              element.Error = res['text.dataStatusError2'];
            } else if (element.Error == Constants.dataStatusError3) {
              element.Error = res['text.dataStatusError3'];
            } else if (element.Error == Constants.dataStatusError4) {
              element.Error = res['text.dataStatusError4'];
            } else if (element.Error == Constants.dataStatusError5) {
              element.Error = res['text.dataStatusError5'];
            } else if (element.Error == Constants.dataStatusError6) {
              element.Error = res['text.dataStatusError6'];
            } else if (element.Error == Constants.dataStatusError7) {
              element.Error = res['text.dataStatusError7'];
            } else if (element.Error == Constants.dataStatusError8) {
              element.Error = res['text.dataStatusError8'];
            } else if (element.Error == Constants.dataStatusError9) {
              element.Error = res['text.dataStatusError9'];
            } else if (element.Error == Constants.dataStatusError10) {
              element.Error = res['text.dataStatusError10'];
            }
          }
        });
      });
    }
  }

  handleGvrtStatus(screenData): string {
    let gvrtStatus: string;
    if (screenData?.Success_KSeF !== null && screenData?.Success_KSeF > 0 && screenData?.GVRT_Status === null) {
      gvrtStatus = 'PENDING';
    } else if (screenData?.Success_KSeF !== null && screenData?.Success_KSeF > 0 && screenData?.GVRT_Status !== null) {
      gvrtStatus = screenData?.GVRT_Status ? screenData.GVRT_Status : 'PENDING';
    } else {
      gvrtStatus = 'NO DATA AVAILABLE';
    }
    return gvrtStatus.toUpperCase();
  }
  getTooltipData(){
    let translationKey = this.isManual ? 'text.gvrtStatusInfoMessageManual' : 'text.gvrtStatusInfoMessage';
    let result = '';
    this.translate.get(translationKey).subscribe(res => {
      result = res;
    });
    return result;
  }
  public inProgressStatus(currentScreenData: currentDataDto): boolean {
    return currentScreenData.Interfacing_with_MoF === 'AUTO' &&
           (currentScreenData.In_Progress_KSeF > 0 && currentScreenData.Status === 'PROCESSED') ||
           this.eyFileStatus(currentScreenData);
  }

  public inProgressStatusEdicom(currentScreenData: currentDataDto): boolean {
    return currentScreenData.Interfacing_with_MoF === 'AUTO' && 
           (currentScreenData.Active_Errors + currentScreenData.Active != currentScreenData.Total_Received &&
            currentScreenData.Status === 'PROCESSED') || 
           this.eyFileStatus(currentScreenData);
  }

  public eyFileStatus(currentScreenData: currentDataDto): boolean {
    return this.eyfileStatusList[currentScreenData.Status] &&
           this.eyfileStatusList[currentScreenData.Status]['showProgressBar'] &&
           this.progressList[currentScreenData.Stage];
  }

  public handleTooltip(currentScreenData: currentDataDto): boolean | string {
    return currentScreenData.In_Progress_KSeF > 0 && currentScreenData.Status === 'PROCESSED' ?
      false :
      this.toolTipNonAuto(currentScreenData);
  }

  public toolTipNonAuto(currentScreenData: currentDataDto): boolean | string {
    let fileStatusList = this.fileStatus(currentScreenData);
    return fileStatusList[currentScreenData.Status] ?
      fileStatusList[currentScreenData.Status]['toolTip'] && currentScreenData.Error :
      false;
  }

  public setStatusColor(currentScreenData: currentDataDto): string {
    let fileStatusList = this.fileStatus(currentScreenData)
    if (currentScreenData.Interfacing_with_MoF === 'AUTO') {
      if (currentScreenData.In_Progress_KSeF > 0 && currentScreenData.Status === 'PROCESSED') {
        return '#ED6500';
      } else {
        return fileStatusList[currentScreenData.Status] ?
          fileStatusList[currentScreenData.Status]['color'] :
          'black';
      }
    } else {
      return fileStatusList[currentScreenData.Status] ?
        fileStatusList[currentScreenData.Status]['color'] :
        'black';
    }
  }

  public setStatusColorEdicom(currentScreenData: currentDataDto): string {
    let fileStatusList = this.fileStatus(currentScreenData);
    if (currentScreenData.Interfacing_with_MoF === 'AUTO') {
      if (currentScreenData.Active + currentScreenData.Active_Errors != currentScreenData.Total_Received && currentScreenData.Status === 'PROCESSED') {
        return '#ED6500';
      } else {
        return fileStatusList[currentScreenData.Status] ?
          fileStatusList[currentScreenData.Status]['color'] :
          'black';
      }
    } else {
      return fileStatusList[currentScreenData.Status] ?
        fileStatusList[currentScreenData.Status]['color'] :
        'black';
    }
  }

  public setStatusColorNONAuto(currentScreenData: currentDataDto): string {
    let fileStatusList = this.fileStatus(currentScreenData)
    return fileStatusList[currentScreenData.Status] ? fileStatusList[currentScreenData.Status]['color'] : 'black';
  }

  public fileStatus1(currentScreenData: currentDataDto): any{
    return currentScreenData.FileStandard === 'EY' ?
      this.eyfileStatusList :
      this.noneyfileStatusList
  }

  public fileStatus(currentScreenData: currentDataDto): any{
    return currentScreenData.FileStandard === 'EY' ?
      this.eyfileStatusList1 :
      this.noneyfileStatusList1
  }

  private handleStatus(currentScreenData: currentDataDto): string {
    let status = '';
    let fileStatusList = this.fileStatus(currentScreenData)
      const isHandleStatus = !['IT'].includes(this.selectedCountry )&& currentScreenData.In_Progress_KSeF > 0 && currentScreenData.Status === 'PROCESSED';
      const isHandleStatus2 = (['IT'].includes(this.selectedCountry) && (currentScreenData.Active_Errors + currentScreenData.Active) != currentScreenData.Total_Received && currentScreenData.Status === 'PROCESSED');
      const isHandleStatus1 = currentScreenData?.Status?.toUpperCase() === 'UPLOADED' && currentScreenData?.Type?.toUpperCase() !== 'EINV' ? fileStatusList['T_INPROGRESS'] : fileStatusList[currentScreenData.Status]
      if (currentScreenData.Interfacing_with_MoF === 'AUTO') {
        status = isHandleStatus || isHandleStatus2 ? "Inprogress" : (isHandleStatus1 ? isHandleStatus1?.["text"] : currentScreenData.Status);
      }
      else if(currentScreenData.Interfacing_with_MoF !== 'AUTO'){
       status = isHandleStatus1 ? isHandleStatus1?.["text"] : currentScreenData.Status;
      }
      return status?.toUpperCase();
  }

  checkCheckBoxvalue(event, row) {
    if (event) {
      if (event.currentTarget.checked)
        this.selectedList.push(row);
      else {
        let tinIndex = this.selectedList.indexOf(row);
        this.selectedList.splice(tinIndex, 1);
      }
    }
  }

  openUploadAttachmentDialog(currentScreenData){
    this.uploadButtonClick.emit(currentScreenData);
  }
  
  updateOutput() {
    this.selected.emit(this.selectedRows);
  }

  updateSourceList(): void {
    const translationKeys = ['text.webUpload', 'text.SFTPUpload', 'text.asyncAPI'];
    this.translate.get(translationKeys).subscribe(res => {
      this.sourceList = {
        WEB: { name: res['text.webUpload'], value: "WEB" },
        SFTP: { name: res['text.SFTPUpload'], value: "SFTP" },
        ASYNC: { name: res['text.asyncAPI'], value: "Async" }
      };
    });
    
  }

  updateEinvoicelist(): void {
    this.translate.get('text.noTransform').subscribe(res => {
      this.einvoiceList = {
        EINV: { name: res },
        B2C: { name: res }
      };
    });
    
  }

  updatefileStatusList(): void {
    const transltionKeys = [
      'text.uploaded',
      'text.inProgress',
      'text.processed',
      'text.failed',
      'text.pendingWithAttach',
      'text.initiated',
      'text.PREUPLOADED',
      'text.transformationFailed',
      'text.T_INPROGRESS'
    ];
    this.translate.get(transltionKeys).subscribe(res => {
      this.eyfileStatusList = {
        UPLOADED: { text: res['text.uploaded'], color: '#168736', showProgressBar: false, toolTip: false },
        INPROGRESS: { text: res['text.inProgress'], color: '#ED6500', showProgressBar: true, toolTip: false },
        PROCESSED: { text: res['text.processed'], color: '#155cb4', showProgressBar: false, toolTip: false },
        FAILED: { text: res['text.failed'], color: '#b9251c', showProgressBar: false, toolTip: true },
        PENDING: { text: res['text.pendingWithAttach'], color: '#ffe600', showProgressBar: false, toolTip: false },
        INITIATED: { text: res['text.initiated'], color: '#ffe600', showProgressBar: false, toolTip: false }
      };
      this.noneyfileStatusList = {
        PREUPLOADED: { text: res['text.PREUPLOADED'], color: '#168736', showProgressBar: false, toolTip: false },
        UPLOADED: { text: res['text.uploaded'], color: '#168736', showProgressBar: false, toolTip: false },
        INPROGRESS: { text: res['text.inProgress'], color: '#ED6500', showProgressBar: true, toolTip: false },
        PROCESSED: { text: res['text.processed'], color: '#155cb4', showProgressBar: false, toolTip: false },
        FAILED: { text: res['text.failed'], color: '#b9251c', showProgressBar: false, toolTip: true },
        T_FAILED: { text: res['text.transformationFailed'], color: '#b9251c', showProgressBar: false, toolTip: true },
        T_INPROGRESS: { text: res['text.T_INPROGRESS'], color: '#ED6500', showProgressBar: true, toolTip: false },
        PENDING: { text: res['text.pendingWithAttach'], color: '#ffe600', showProgressBar: false, toolTip: false },
        INITIATED: { text: res['text.initiated'], color: '#ffe600', showProgressBar: false, toolTip: false }
      };
    });
  }

  public originalStatusNames(){
    this.eyfileStatusList1 = {
      UPLOADED: { text: 'Uploaded', color: '#168736', showProgressBar: false, toolTip: false },
      INPROGRESS: { text: 'InProgress', color: '#ED6500', showProgressBar: true, toolTip: false },
      PROCESSED: { text: 'Processed', color: '#155cb4', showProgressBar: false, toolTip: false },
      FAILED: { text: 'Failed', color: '#b9251c', showProgressBar: false, toolTip: true },
      PENDING: { text: 'Pending', color: '#ffe600', showProgressBar: false, toolTip: false },
      INITIATED: { text: 'Initiated', color: '#ffe600', showProgressBar: false, toolTip: false }
    };
    this.noneyfileStatusList1 = {
      PREUPLOADED: { text: 'Uploaded', color: '#168736', showProgressBar: false, toolTip: false },
      UPLOADED: { text: 'Uploaded', color: '#168736', showProgressBar: false, toolTip: false },
      INPROGRESS: { text: 'InProgress', color: '#ED6500', showProgressBar: true, toolTip: false },
      PROCESSED: { text: 'Processed', color: '#155cb4', showProgressBar: false, toolTip: false },
      FAILED: { text: 'Failed', color: '#b9251c', showProgressBar: false, toolTip: true },
      T_FAILED: { text: 'Failed', color: '#b9251c', showProgressBar: false, toolTip: true },
      T_INPROGRESS: { text: 'InProgress', color: '#ED6500', showProgressBar: true, toolTip: false },
      PENDING: { text: 'Pending', color: '#ffe600', showProgressBar: false, toolTip: false },
      INITIATED: { text: 'Initiated', color: '#ffe600', bg:'', showProgressBar: false, toolTip: false }
    };
  }

  getTextColor(status: string) {
    const statusMap = {
      'PENDING': { color: '#000' },
      'INITIATED': { color: '#000' },
      'INPROGRESS': { color: '#fff' },
      'PROCESSED': { color: '#fff' },
      'FAILED': { color: '#fff' },
      'DEFAULT': { color: '#fff' }
    };
    const upperCaseStatus = status?.toUpperCase();
    return statusMap[upperCaseStatus]?.color || statusMap['DEFAULT']?.color;
  }
  
  getGVRTStatus(status: string) {
    const statusMap = {
      'PENDING': { text: 'Pending', bgColor: '#168736', color: "#fff", showProgressBar: false, toolTip: false },
      'INPROGRESS': { text: 'InProgress', bgColor: '#ED6500', color: "#fff", showProgressBar: false, toolTip: false },
      'SENT': { text: 'Sent', bgColor: '#155cb4', color: "#fff", showProgressBar: false, toolTip: true },
      'FAILED': { text: 'Failed', bgColor: '#b9251c', color: "#fff", showProgressBar: false, toolTip: true },
      'NO DATA AVAILABLE': { text: 'No Data Available', bgColor: "#fff", color: '#000000', showProgressBar: false, toolTip: false }
    };
    const uppercaseStatus = status?.toUpperCase();
    return statusMap[uppercaseStatus] || statusMap['NO DATA AVAILABLE'];
  }

  clearFilter() {
    this.dt.clear();
  }

  onGlobalSearch(searchText: string): void {
    if (!this.isSidebarLayout) {
      this.dt?.filterGlobal(searchText, 'contains');
      return;
    }
    const term = (searchText || '').trim().toLowerCase();
    if (!term) {
      if (this.preSearchScreenData.length) {
        this.currentScreenData = [...this.preSearchScreenData];
        this.preSearchScreenData = [];
      }
      this.isGlobalFilterActive = false;
      this.updateFooterMessage();
      return;
    }
    // Snapshot currentScreenData before first filter to allow restoring on clear
    if (!this.preSearchScreenData.length) {
      this.preSearchScreenData = [...this.currentScreenData];
    }
    this.currentScreenData = this.preSearchScreenData.filter(row => {
      const displayText = this.getRowDisplayText(row);
      return displayText.toLowerCase().includes(term);
    });
    this.isGlobalFilterActive = true;
    this.updateFooterMessage();
  }

  clearGlobalSearch(): void {
    if (!this.globalSearchText) return;
    this.globalSearchText = '';
    if (this.preSearchScreenData.length) {
      this.currentScreenData = [...this.preSearchScreenData];
      this.preSearchScreenData = [];
    }
    this.isGlobalFilterActive = false;
  }

  updateFooterMessage(): void {
    if (!this.isSidebarLayout) return;

    const showingText = this.translate.instant('text.showing');
    const toText = this.translate.instant('text.to');
    const ofText = this.translate.instant('text.of');
    const entriesText = this.translate.instant('text.entries');

    if (this.isGlobalFilterActive) {
      const total = this.preSearchScreenData.length || this.totalRecords;
      this.footerMessage = `${showingText} ${this.currentScreenData.length} ${ofText} ${total} ${entriesText}`;
    } else {
      const first = this.currentPageIndex * (this.dt?.rows || this.lazyRows);
      const rows = this.dt?.rows || this.lazyRows;
      const last = Math.min(first + rows, this.totalRecords);
      const start = this.totalRecords > 0 ? first + 1 : 0;
      this.footerMessage = `${showingText} ${start} ${toText} ${last} ${ofText} ${this.totalRecords} ${entriesText}`;
    }
  }

  /**
   * Builds a searchable string from the row that mirrors visible UI text,
   * including composed columns like Status with progress percentage.
   */
  private getRowDisplayText(row: any): string {
    const parts: string[] = [];

    // Basic visible columns
    parts.push(row.Date || '');
    parts.push(row.System_ID || '');
    parts.push(row.Source || '');
    parts.push(row.FileType || '');
    parts.push(row.FileID || '');
    parts.push(row.OrgFileName || '');

    // Status column - compose the displayed text like the template does
    const statusList = this.fileStatus1(row);
    const statusEntry = statusList?.[row.Status];
    let statusText = statusEntry?.text || row.Status || '';
    const isAuto = row.Interfacing_with_MoF === 'AUTO';
    const showProgress = isAuto ? this.inProgressStatus(row) : this.eyFileStatus(row);
    if (showProgress && this.progressList[row.Stage] != null) {
      statusText += ' - ' + this.progressList[row.Stage] + '%';
    }
    parts.push(statusText);

    // Numeric / remaining columns
    parts.push((row.Total_Received ?? 0).toString());
    parts.push(row.TransformationName || '');
    parts.push((row.Active_Errors ?? 0).toString());
    parts.push((row.Active ?? 0).toString());
    if (!this.isManual) {
      parts.push((row.In_Progress_KSeF ?? 0).toString());
      parts.push((row.Success_KSeF ?? 0).toString());
      parts.push((row.Errors_KSeF ?? 0).toString());
    }

    return parts.join(' ');
  }
     
  getColumnHeaderText(status: string) {
    const countryTextMap = {
      'RO': {
        'inprogress': 'text.inprogressMOF',
        'success': 'text.successMof',
        'error': 'text.errorsMof'
      },
      'AU': {
        'inprogress': 'text.inprogressPeppol',
        'success': 'text.successPeppol',
        'error': 'text.errorPeppol'
      },
      'MY': {
        'inprogress': 'text.inprogressIRBM',
        'success': 'text.successIRBM',
        'error': 'text.errorIRBM'
      },
      'FR': {
        'inprogress': 'text.inprogressPA',
        'success': 'text.successPA',
        'error': 'text.errorPA'
      },
      'default': {
        'inprogress': 'text.inprogressSDI',
        'success': 'text.successSDI',
        'error': 'text.errorsSDI'
      }
    };

    const country = countryTextMap[this.countryLocation] || countryTextMap['default'];
    return this.translate.instant(country[status]);
  }

  // Server-side lazy event handlers
  onPageEvent(event: any): void {
    this.clearGlobalSearch();
    this.currentPageIndex = Math.floor(event.first / event.rows);
    this.tableEvent.emit({
      type: 'pageChange',
      data: { pageCount: this.currentPageIndex + 1, pageSize: event.rows }
    });
    this.updateFooterMessage();
  }

  onSortEvent(event: any): void {
    if (!this.dt) return;
    this.clearGlobalSearch();

    if (this.currentSortField === event.field) {
      // Same column — cycle: null → true (asc) → false (desc) → null (unsorted)
      if (this.isSorted == null || this.isSorted === undefined) {
        this.isSorted = true;
        this.currentPageIndex = 0;
        this.tableEvent.emit({ type: 'sortChange', data: [{ field: event.field, order: event.order }] });
      } else if (this.isSorted == true) {
        this.isSorted = false;
        this.currentPageIndex = 0;
        this.tableEvent.emit({ type: 'sortChange', data: [{ field: event.field, order: event.order }] });
      } else if (this.isSorted == false) {
        this.isSorted = null;
        this.currentSortField = null;
        this.currentPageIndex = 0;
        this.tableEvent.emit({ type: 'sortChange', data: [] });
        // Reset on next tick so it overrides PrimeNG's internal sort update
        setTimeout(() => {
          if (this.dt) {
            this.dt.sortField = null;
            this.dt.sortOrder = 1;
            this.dt.tableService.onSort(null);
          }
        });
      }
    } else {
      this.isSorted = true;
      this.currentSortField = event.field;
      this.currentPageIndex = 0;
      this.tableEvent.emit({ type: 'sortChange', data: [{ field: event.field, order: event.order }] });
    }
    this.updateFooterMessage();
  }

  customSortFunction(event: any) {
    if (this.isSorted == null || this.isSorted === undefined) {
            this.isSorted = true;
            this.sortTableData(event);
        } else if (this.isSorted == true) {
            this.isSorted = false;
            this.sortTableData(event);
        } else if (this.isSorted == false) {
            this.isSorted = null;
            this.currentScreenData = [...this.initialDataScreenData];
            this.dt.reset();
        }

  }

  onFilterSubmit(event: Record<string, any>): void {
    this.clearGlobalSearch();
    this.resetSort();
    this.filterSubmit.emit(event);
  }

  onChipRemove(event: { fieldName: string; value?: any }): void {
    this.clearGlobalSearch();
    this.resetSort();
    this.chipRemove.emit(event);
  }

  onChipClearAll(): void {
    this.clearGlobalSearch();
    this.resetSort();
    this.chipClearAll.emit();
  }
  
  sortTableData(event: any) {
    const field = event.field;
    const order = this.isSorted ? 1 : -1;
    this.currentScreenData.sort((a, b) => {
      const rawA = a[field];
      const rawB = b[field];
      const numA = Number(rawA);
      const numB = Number(rawB);

      // If both values are numeric, compare as numbers
      if (rawA != null && rawA !== '' && !isNaN(numA) &&
          rawB != null && rawB !== '' && !isNaN(numB)) {
        return (numA - numB) * order;
      }

      // Otherwise compare as strings
      const valueA = rawA ? rawA.toString().toLowerCase() : '';
      const valueB = rawB ? rawB.toString().toLowerCase() : '';
      if (valueA < valueB) {
          return -1 * order;
      } else if (valueA > valueB) {
          return 1 * order;
      } else {
          return 0;
      }
    });
  }

  resetSort(): void {
    this.isSorted = null;
    this.currentSortField = null;
    if (this.dt) {
      this.dt.sortField = null;
      this.dt.sortOrder = 1;
      this.dt.tableService.onSort(null);
    }
  }

  onClearSelectedRows(event: any): void {
    this.selectedRows = [];
    this.clearSelectedRowsEvent.emit(event);
  }

  clearedSelectedRows(): void {
    this.selectedRows = [];
  }

  getSelectedRows(): any[] {
    if (!this.selectedRows?.length || !this.tableData?.length) {
      return [];
    }
    const selectedFileIds = new Set(this.selectedRows.map(row => row.FileID));
    return this.tableData.filter(record => selectedFileIds.has(record.FileID));
  }
}


class currentDataDto {
  FromDate?: any;
  ToDate?: any;
  MOFInterface?: string;
  Entity?: any;
  Source?: string;
  Type?: string;
  Id?: any;
  Status?: string;
  Active?: any;
  Inactive?: any;
  Active_Errors?: any;
  InActive_Errors: any;
  DownloadDate: any;
  Date: any;
  Error: string;
  FileType: string;
  FileID: any;
  FileName: string;
  FileStandard: string;
  Interfacing_with_MoF: string;
  OrgFileName: string;
  Stage: string;
  Structure: string;
  System_ID: any;
  Total_Received: any;
  In_Progress_KSeF: any;
  Transformation: any;
  Success_KSeF: any;
  Errors_KSeF: any;
  FileTemplate: any;
  TransformationName: any;
  GVRT_Status: any;
  GVRT_StartDT: any;
  dbStatus: any;

  constructor(FromDate, ToDate, MOFInterface, Entity, Source, FileType, Type, Id, Status, Active, Active_Errors, DownloadDate, Date, Error, FileID, FileName,
    FileStandard, Interfacing_with_MoF, OrgFileName, Stage, Structure, System_ID, Total_Received, In_Progress_KSeF, Transformation,
    Success_KSeF, Errors_KSeF, Inactive, InActive_Errors, FileTemplate, TransformationName, GVRT_Status, GVRT_StartDT, dbStatus) {
    this.FromDate = FromDate;
    this.ToDate = ToDate;
    this.MOFInterface = MOFInterface;
    this.Entity = Entity;
    this.Source = Source;
    this.Type = Type;
    this.Id = Id;
    this.Active = Active;
    this.Active_Errors = Active_Errors;
    this.DownloadDate = DownloadDate;
    this.Date = Date;
    this.Error = Error;
    this.FileType = FileType;
    this.FileID = FileID;
    this.FileName = FileName;
    this.FileStandard = FileStandard;
    this.Interfacing_with_MoF = Interfacing_with_MoF;
    this.OrgFileName = OrgFileName;
    this.Stage = Stage;
    this.Structure = Structure;
    this.System_ID = System_ID;
    this.Total_Received = Total_Received;
    this.Status = Status;
    this.In_Progress_KSeF = In_Progress_KSeF;
    this.Transformation = Transformation;
    this.Success_KSeF = Success_KSeF;
    this.Errors_KSeF = Errors_KSeF;
    this.Inactive = Inactive;
    this.InActive_Errors = InActive_Errors;
    this.FileTemplate = FileTemplate;
    this.TransformationName = TransformationName;
    this.GVRT_Status = GVRT_Status;
    this.GVRT_StartDT = GVRT_StartDT;
    this.dbStatus = dbStatus;
  }
}
